import * as React from "react";
import { InputProps } from "../IInputFieldProps";
import classNames from "classnames";

import "../inputfield.scss";

export interface CheckboxFieldOption {
  label: string;
  value: string;
  id: string;
}

export interface CheckboxGroupInputFieldProps {
  name: string;
  displayStyle: string;
  className?: string;
  options: CheckboxFieldOption[];
  onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void | null;
  input?: InputProps;
  inputRef?: React.RefCallback<HTMLInputElement>;
}

export const CheckboxGroupInputField = (props: CheckboxGroupInputFieldProps) => {
  const labelClasses = classNames("checkbox-container", props.className ? props.className : "");

  const selected = props.input?.value && Array.isArray(props.input.value) ? props.input.value : [];

  const isChecked = (option: CheckboxFieldOption) => selected.some((item) => item === option.value);

  return (
    <div className="checkbox-group">
      {props.options &&
        props.options.map((option, index) => {
          return (
            <label
              className={labelClasses}
              key={index}
              id={`${option.id}-label`}
              style={{ display: props.displayStyle }}
            >
              <input
                {...props.input}
                id={option.id}
                type="checkbox"
                ref={props.inputRef}
                name={props.name}
                value={option.value}
                checked={isChecked(option)}
                onChange={(event) => {
                  if (!props.onChange) {
                    return;
                  }

                  if (!isChecked(option)) {
                    props.onChange([...selected, option.value] as any);
                  } else {
                    props.onChange(selected.filter((item) => item !== option.value) as any);
                  }
                }}
                role="checkbox"
                aria-checked={isChecked(option)}
                aria-labelledby={`${option.id}-label`}
              />
              <span className="checkmark" />

              {option.label}
            </label>
          );
        })}
    </div>
  );
};
